import { render, staticRenderFns } from "./DecoratedField.vue?vue&type=template&id=6d2c94f1"
import script from "./DecoratedField.vue?vue&type=script&lang=js"
export * from "./DecoratedField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports